import { OverrideSettings } from 'src/types/override-settings';

import { Link } from './link';
import { Project } from './project';
import { Branch } from './refs';
import { User } from './user';
import { Workspace } from './workspace';

type BBRepository = {
  created_on?: string;
  description?: string;
  fork_policy?: string;
  full_name: string;
  has_issues?: boolean;
  has_wiki?: boolean;
  is_private?: boolean;
  landing_page?: string;
  language?: string;
  links: {
    avatar: Link;
    branches?: Link;
    clone: [Link & { name: 'https' }, Link & { name: 'ssh' }];
    commits?: Link;
    downloads?: Link;
    forks?: Link;
    hooks?: Link;
    html: Link;
    pullrequests?: Link;
    self: Link;
    tags?: Link;
    watchers?: Link;
  };
  mainbranch?: Branch;
  name: string;
  override_settings?: OverrideSettings;
  owner?: User;
  parent?: BBRepository;
  project?: Project;
  size?: number;
  slug?: string;
  type: 'repository';
  updated_on?: string;
  uuid: string;
  website?: string | null;
  workspace?: Workspace;
};

declare global {
  namespace BB {
    type Repository = BBRepository;
  }

  namespace Models {
    type Repository<T extends DeepPartial<BBRepository>> = T;
  }
}

export type Repository = BBRepository;
